export default {"src":"/_next/static/media/continuous_support_improvement.48d12d29.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};